import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class FinancementService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/financement/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/financement/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/financement/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/financement/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/financement/delete/${id}`), callback);
   

}